import React from 'react';
import Layout from "../../../Component/Layout";

// 🔴 Same imports as Sales
import { TILE_REGISTRY } from '../../../Component/Favourite/TileRegistry';
import PinToHome from '../../../Component/Favourite/PinToHome';

function CustomerRelationshipManagement() {

    // 🔴 Filter tiles for this module
    const cards = Object.values(TILE_REGISTRY).filter(
        t => t.moduleName === "Customer Relationship Management"
    );

    const handleNavigate = (path) => {
        window.location.href = path;
    };

    return (
        <Layout>
            <div style={{ padding: "30px 40px", backgroundColor: "#f8fafc", minHeight: "calc(100vh - 60px)" }}>
                
                {/* --- Page Header --- */}
                <div style={{ marginBottom: "35px" }}>
                    <h2 style={{ margin: "0 0 8px 0", color: "#0f172a", fontWeight: "700", fontSize: "28px" }}>
                        Customer Relationship Management
                    </h2>
                    <p style={{ color: "#64748b", margin: 0, fontSize: "15px" }}>
                        Manage customer support and relationships efficiently.
                    </p>
                </div>

                {/* --- Tiles Grid --- */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                        gap: "24px",
                    }}
                >
                    {cards.map((item) => {
                        const IconComponent = item.icon; 

                        return (
                            <div
                                key={item.id}
                                style={{
                                    background: "#ffffff", 
                                    borderRadius: "16px", 
                                    border: "1px solid #e2e8f0",
                                    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)",
                                    padding: "24px", 
                                    cursor: "pointer", 
                                    position: "relative",
                                    display: "flex", 
                                    flexDirection: "column",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    height: "160px"
                                }}
                                onClick={() => handleNavigate(item.path)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-6px)";
                                    e.currentTarget.style.boxShadow = "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)";
                                    e.currentTarget.style.borderColor = "#cbd5e1";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)";
                                    e.currentTarget.style.borderColor = "#e2e8f0";
                                }}
                            >
                                {/* Top Row */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "auto" }}>
                                    
                                    <div style={{ 
                                        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", 
                                        color: "#3b82f6", 
                                        padding: "14px", 
                                        borderRadius: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <IconComponent size={26} />
                                    </div>
                                    
                                    <div style={{ position: "relative", zIndex: 10, marginTop: "-5px", marginRight: "-5px" }}>
                                        <PinToHome tileId={item.id} />
                                    </div>
                                </div>

                                {/* Bottom Row */}
                                <div>
                                    <h5 style={{ fontSize: "16px", fontWeight: "600", color: "#0f172a", margin: "0 0 6px 0" }}>
                                        {item.name}
                                    </h5>
                                    <p style={{ fontSize: "13px", color: "#64748b", margin: 0, fontWeight: "500" }}>
                                        Open Module <span style={{ marginLeft: "4px", fontSize: "14px" }}>→</span>
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Layout>
    );
}

export default CustomerRelationshipManagement;